<po-page-default [p-title]="page.title" [p-breadcrumb]="page.breadcrumb" [p-actions]="page.actions">

    <po-divider class="po-md-12" [p-label]="informacoesFornecedor"></po-divider>
    <po-accordion class="po-row">
        <po-accordion-item p-label="Filtros">
            <po-input class="po-md-2" p-label='Nota fiscal' p-clean="true" [(ngModel)]="filtros.F1_DOC"></po-input>
            <po-input class="po-md-2" p-label='Serie' p-clean="true" [(ngModel)]="filtros.F1_SERIE" (click)="abrirMensagemGov()"></po-input>
            <po-datepicker class="po-md-2" p-label='Emissao' p-clean="true" [(ngModel)]="filtros.F1_EMISSAO">
            </po-datepicker>
            <po-button class="po-md-2 po-mt-4" p-label="Filtrar" p-icon="po-icon-search" (click)="filtrarNotaFiscal()">
            </po-button>
        </po-accordion-item>
    </po-accordion>

    <po-table [p-columns]="tableColumns" [p-items]="tableItems" p-sort="true" p-striped="true" p-hide-text-overflow="true" [p-height]="tableHeight" p-selectable="true" p-single-select="true" (p-selected)="selected($event)" (p-unselected)="unSelected($event)">
    </po-table>

    <app-pagination [(currentPage)]="pagination.currentPage" (pageChanged)="onPageChange($event)" [(totalItems)]="pagination.totalItems" [itemsPerPage]="pagination.itemsPerPage">
    </app-pagination>

</po-page-default>

<po-loading-overlay *ngIf="loading" p-text="Carregando"></po-loading-overlay>

<po-modal #mensagemGov p-title="Atenção" >
    <div class="modal-alert">
        <span class="alert-triangle"></span>

        <h3>
            Informamos que, a partir de fevereiro/2026, haverá a mudança da série
            de RFB/UNI para GOV no portal de fornecedores.
        </h3>
       
    </div>
</po-modal>


<po-modal #mensagemInclusao p-title="Atenção">
    <div>
        <h3 class="mensagem-alerta">
            {{mensagemNota}}
        </h3>
    </div>
</po-modal>

<po-modal #anexoModal p-title="Anexar Documento">
    <div>
        <h3 class="mensagem-alerta">É obrigatório anexar Nota fiscal em PDF</h3>
    </div>
    <!-- ENVIAR QUAL A NOTA QUE ESTOU ENVIANDO () -->
    <div class="po-mt-2 po-row">
        <po-upload #upload class="po-md-6" [p-url]="uploadURL" (p-error)="uploadError($event)" [p-restrictions]="fileRestrictions" (p-upload)="anexaArquivo($event)" (p-success)="uploadSucess($event)">
        </po-upload>

        <po-button p-icon="po-icon po-icon-eye-off" [p-label]="labelButton" (click)="exibeFiles()"></po-button>

        <po-button *ngIf="item.length > 0 " class="po-md-5" p-icon="po-icon po-icon-download" p-label="Baixar arquivo (s) selecionado (s)" (click)="downloadFiles()"></po-button>
    </div>

    <po-table *ngIf="mostrarArquivos" 
        [p-columns]="tableConhecimentoColumns" 
        [p-items]="tableConhecimentoItems" p-sort="true" p-striped="true" p-selectable="true" 
        (p-selected)="selectedItem($event)"
        (p-unselected)="unSelectedItem($event)"
        (p-all-selected)="allSelectedItem($event)"
        (p-all-unselected)="unAllSelectedItem($event)">
    </po-table>
</po-modal>
